export default "__VITE_ASSET__BKlIC1kn__"